import { apiClientV2 } from "./configs/axiosConfig";

export interface StartConfigResponse {
  status: string;
  data: {
    logo: string;
    primary_color: string;
    brand: {
      name: string;
      label: string;
    };
  };
  message: string;
}

export interface StartConfigRequest {
  data: {
    base_url: string;
  };
}

export class ConfigApi {
  static async getStartConfig(baseUrl: string = "prove"): Promise<StartConfigResponse> {
    const response = await apiClientV2.post<StartConfigResponse>("/social_hub/start_config", {
   
   
        base_url: baseUrl
 
    });
    return response.data;
  }
}
